import { useCallback, useEffect, useState } from 'react';
import { Button, Link } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import { OneMealService } from '../../services/OneMealService';
import CallButton from '../Common/CallButton/CallButton';
import { UserType } from '../../enums/common';
import { formatDate } from '../../utils/DateTimeUtils';

const oneMealService = new OneMealService();

interface InputProps {
    houseId: number;
    filter?: any;
}

const HouseOmsTableTab = ({ houseId, filter = {} }: InputProps) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [data, setData] = useState<any[]>([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    const refreshData = useCallback(() => {
        setLoading(true);
        oneMealService
            .getAllOneMealServiceForHouse(houseId, rowsPerPage, rowsPerPage * page, { order: 'DESC', field: 'createdAt' }, { ...filter })
            .then((res) => {
                setData(res?.data ?? []);
                setTotal(res?.total ?? res?.count ?? 0);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [houseId, page, rowsPerPage]);

    useEffect(() => {
        refreshData();
    }, [refreshData]);

    const columns: CommonListColumn[] = [
        { label: 'Id', field: 'id' },
        { label: 'Customer Name', field: 'customerName' },
        {
            label: 'Customer Address',
            render: (row) => [row?.localityName, row?.areaName, row?.cityName].filter(Boolean).join(', ') || 'Not Available',
        },
        { label: 'Cook Id', field: 'cookId' },
        { label: 'Cook Name', field: 'cookName' },
        {
            label: 'Cook Mobile',
            stopRowClick: true,
            render: (row) => row?.cookPhoneNumber ? (
                <CallButton
                    toPhoneNumber={row?.cookPhoneNumber}
                    userType={UserType.COOK}
                    referenceId={row?.id}
                    referenceModelName="ONE_MEAL_SERVICE"
                />
            ) : '---',
        },
        {
            label: 'Date',
            render: (row) => formatDate(row?.date),
        },
        { label: 'Time', field: 'time' },
        { label: 'Status', field: 'status', type: 'status' },
        { label: 'Payment Status', field: 'paymentStatus', type: 'status' },
        {
            label: 'Actions',
            stopRowClick: true,
            render: (row) => (
                <Link href={`/#/OneMealService/${row.id}/show`}>
                    <Button variant="contained" color="primary" size="small">Show</Button>
                </Link>
            ),
        },
    ];

    return (
        <CommonListTable
            columns={columns}
            data={data}
            loading={loading}
            page={page}
            rowsPerPage={rowsPerPage}
            total={total}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowsPerPageOptions={[25, 50, 100]}
            emptyText="No One Meal Service found"
        />
    );
};

export default HouseOmsTableTab;
